import cmpStatCards from "./modules/cmp-stat-cards";
import cmpDatePicker from "./modules/cmp-date-picker";
import cmpModal from "./modules/cmp-modal";

export const componentScripts = {
    cmpStatCards: cmpStatCards,
    cmpDatePicker: cmpDatePicker,
	cmpModal: cmpModal,
}
